import { render } from "./points.vue?vue&type=template&id=3a00c5c4&scoped=true&ts=true"
import script from "./points.vue?vue&type=script&lang=ts"
export * from "./points.vue?vue&type=script&lang=ts"

import "./points.vue?vue&type=style&index=0&id=3a00c5c4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a00c5c4"]])

export default __exports__